import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { AuthSchema } from '../types/AuthSchema';
import { defaultState } from '../../config/defaultState';
import { authByEmail } from '../services/authByEmail';
import { IErrors } from '../types/Errors';

const initialState: AuthSchema = {
  ...defaultState,
  isLoading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setEmail: (state: Draft<AuthSchema>, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPassword: (state: Draft<AuthSchema>, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    // setRemember: (state:Draft<AuthSchema>, action:PayloadAction<boolean>) => {
    //   state.remember = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authByEmail.pending, (state: Draft<AuthSchema>) => {
        state.isLoading = true;
        state.errors = undefined;
      })
      .addCase(authByEmail.fulfilled, (state: Draft<AuthSchema>) => {
        state.isLoading = false;
      })
      .addCase(authByEmail.rejected, (state: Draft<AuthSchema>, action) => {
        state.isLoading = false;
        state.errors = action.payload as IErrors;
      });
  },
});

export const { actions: authActions } = authSlice;
export const { reducer: authReducer } = authSlice;
